import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import { ConversationList } from "../../../../model/chats/ChatListModel";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { GroupResults } from "../../../../model/chats/GroupConversationDetailsModel";
import ChatsProvider from "../chats/ChatsProvider";
import GroupChatInfoProvider from "./GroupChatInfoProvider";
import {
  GroupConversationInfo,
  GroupInfoMember,
} from "../../../../model/chats/GroupChatInfoModel";
import { useDispatch } from "react-redux";
import { updateChatGroupTeam } from "../../../../libraries/state_reducers/widget/DetailConnectDeptTeamReducer";
import {
  addModal,
  ModalInterface,
  removeModal,
} from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";

type GroupChatInfoContextType = {
  chatSelected: ConversationList | null;
  groupDetail: GroupConversationInfo | null;
  groupInfo: GroupResults | null;

  handleClickMember: (member: GroupInfoMember) => void;
  handleNavigateMedia: () => void;
};

const GroupChatInfoContext = createContext<
  GroupChatInfoContextType | undefined
>(undefined);

export const GroupChatInfoContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const type: number = ResponsiveDeviceType();

  const dispatch = useDispatch();
  const modals = useSelector((state: RootState) => state.modals.list);

  const chatSelectedRef = useRef<ConversationList | null>(null);

  const [chatSelected, setChatSelected] = useState<ConversationList | null>(
    null
  );

  const [groupDetail, setGroupDetail] = useState<GroupConversationInfo | null>(
    null
  );

  const groupInfo: GroupResults | null =
    ChatsProvider.getChatConversationDetailSession();

  const getSelectedChatSession = () => {
    const chatsChatSelectedSession = SessionStorage.getValue(
      StorageKeys.chats_chat_selected
    );

    if (UtilityHelper.isNotEmpty(chatsChatSelectedSession)) {
      const chatSelected: ConversationList = JSON.parse(
        chatsChatSelectedSession
      );

      chatSelectedRef.current = chatSelected;
      setChatSelected(chatSelected);

      getGroupInfo();
    }
  };

  const getGroupInfo = async () => {
    const detailResult = await GroupChatInfoProvider.getGroupInfoAPI(
      chatSelectedRef.current?.conv_id!
    );

    setGroupDetail(detailResult);
  };

  const handleNavigateMedia = async () => {
    if (type !== 3) {
      const lastModal: ModalInterface = modals[modals.length - 1];
      if ((lastModal.screenMobileView ?? false) === true) {
        //window.history.back();
        dispatch(removeModal(ModalKeys.chat_group_info));
      }

      await UtilityHelper.delay(100);
      dispatch(
        addModal({
          id: ModalKeys.chat_media,
          title: "media",
          size: "lg",
          screenMobileView: type === 3 ? false : true,
        })
      );
    }
  };

  const handleClickMember = (member: GroupInfoMember) => {
    dispatch(updateChatGroupTeam(member));
    dispatch(
      addModal({
        id: ModalKeys.connect_detail_branch_team,
        title: member?.name!,
        size: "md",
        allowBottomSheet: true,
        hideHeader: true,
        bottomSheetHideTitle: true,
      })
    );
  };

  useEffect(() => {
    getSelectedChatSession();
    // eslint-disable-next-line
  }, []);

  return (
    <GroupChatInfoContext.Provider
      value={{
        chatSelected,
        groupInfo,
        groupDetail,
        handleClickMember,
        handleNavigateMedia,
      }}
    >
      {children}
    </GroupChatInfoContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const GroupChatInfoContextImport = () => {
  const context = useContext(GroupChatInfoContext);
  if (!context) {
    throw new Error(
      "GroupChatInfoContextImport must be used within a GroupChatInfoContextProvider"
    );
  }
  return context;
};
